import { vars } from "@styles/theme.css"
import Heading from "components/Heading"
import Loading from "components/shared/Loading"
import { useTranslation } from "next-i18next"

import * as s from "./ProcessingView.css"

type Props = {}

function ProcessingView({}: Props) {
  const { t } = useTranslation()

  return (
    <div className={s.wrapper}>
      <div className={s.innerWrapper}>
        <Heading color={vars.colors.primary.light} variant="3">
          {t("processingView.message")}
        </Heading>
        <Loading />
      </div>
    </div>
  )
}

export default ProcessingView
// export type { Props as ProcessingViewProps }
